var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"share-option",attrs:{"variant":"outline-light"}},[_c('img',{staticClass:"share-option-icon",attrs:{"src":_vm.icon,"alt":_vm.alt}}),_c('div',{staticClass:"share-option-text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }